import utilsActions from 'utils/actions/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case utilsActions.DOWNLOAD_POSTER_REQUEST:
    case utilsActions.FETCH_POSTER_URL_REQUEST:
    case utilsActions.DOWNLOAD_POSTER_FAILURE:
    case utilsActions.FETCH_POSTER_URL_FAILURE: {
      return {
        ...state,
        ...action.error,
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/reducers/error/error.js